import React, { useContext, useEffect } from 'react'
import PresentationContext from '../../PresentationContext'

const BreakdownRow = ({
    breakdownValue,
    coverageValue,
    durationValue,
    catValue,

    breakdownChange,
    coverageChange,
    durationChange,
    catChange,

    removeNone,
    showSliderPicker,
    hideBreakdown,
    hideCoverage,
    hideDuration,

    showCat,
    includeAccumulative,
}) => {
    const { coverageLevels } = useContext(PresentationContext)
    return (
        <form>
            <div className="breakdown-row">
                {!hideBreakdown && (
                    <div className="breakdown-item">
                        <label>Gross/Net:</label>

                        <select
                            value={breakdownValue || ''}
                            onChange={(event) => {
                                const {
                                    target: { value },
                                } = event
                                breakdownChange(value)
                            }}
                        >
                            <option value="Gross">Gross</option>
                            <option value="Net">Net</option>
                        </select>
                    </div>
                )}

                {!hideCoverage && (
                    <div className="breakdown-item">
                        <label>Additional Coverage Level:</label>
                        <select
                            value={coverageValue || ''}
                            onChange={(event) => {
                                const {
                                    target: { value },
                                } = event
                                coverageChange(value)
                            }}
                        >
                            {!removeNone && (
                                <option value="None" key="None">
                                    None
                                </option>
                            )}

                            {coverageLevels &&
                                coverageLevels.map((_) => (
                                    <option value={_.key} key={_.key}>
                                        {_.value}
                                    </option>
                                ))}
                        </select>
                    </div>
                )}
                {showCat && (
                    <div className="breakdown-item">
                        <label>Show CAT:</label>
                        <select
                            value={catValue || 'No'}
                            onChange={(event) => {
                                const {
                                    target: { value },
                                } = event
                                catChange(value)
                            }}
                        >
                            <option value="No">No</option>
                            <option value="Yes">Yes</option>
                        </select>
                    </div>
                )}
                {!hideDuration && (
                    <div className="breakdown-item">
                        <label>
                            {includeAccumulative
                                ? 'Annual/Monthly/Accumulative: '
                                : 'Premium: Annual/Monthly'}
                        </label>
                        <select
                            value={durationValue || ''}
                            onChange={(event) => {
                                const {
                                    target: { value },
                                } = event
                                durationChange(value)
                            }}
                        >
                            <option value="Annual">Annual</option>
                            <option value="Monthly">Monthly</option>
                            {includeAccumulative && (
                                <option value="Accumulative">Accumulative</option>
                            )}
                        </select>
                    </div>
                )}
            </div>
        </form>
    )
}

export default BreakdownRow
